// src/pages/ProfilePage.jsx

import React from "react";
import UserProfile from "../components/UserProfile";
import "./ProfilePage.css";

const ProfilePage = () => {
  return (
    <main className="profile-page" aria-label="Profile page">
      <div className="profile-page__shell">
        <UserProfile />
      </div>
    </main>
  );
};

export default ProfilePage;